import startCase from 'lodash/startCase';
import AmazonIcon from './platforms/component-lib.esm8.js';
import AppleIcon from './platforms/component-lib.esm.js';
import ApplePodcastIcon from './platforms/component-lib.esm5.js';
import BandcampIcon from './platforms/component-lib.esm9.js';
import BehanceIcon from './platforms/component-lib.esm12.js';
import BuyMeACoffeeIcon from './platforms/component-lib.esm10.js';
import ChatIcon from './component-lib.esm90.js';
import ClubhouseIcon from './platforms/component-lib.esm16.js';
import DiscordIcon from './platforms/component-lib.esm11.js';
import EmailIcon from './component-lib.esm23.js';
import EtsyIcon from './platforms/component-lib.esm15.js';
import FacebookLetterFIcon from './social-media/component-lib.esm2.js';
import FlickrIcon from './platforms/component-lib.esm14.js';
import GoogleMyBusinessIcon from './platforms/component-lib.esm20.js';
import GithubIcon from './platforms/component-lib.esm13.js';
import InstagramIcon from './social-media/component-lib.esm4.js';
import KoFiIcon from './platforms/component-lib.esm4.js';
import LineIcon from './platforms/component-lib.esm17.js';
import LinkedinIcon from './social-media/component-lib.esm5.js';
import MastodonIcon from './social-media/component-lib.esm6.js';
import MediumIcon from './platforms/component-lib.esm22.js';
import MusoIcon from './platforms/component-lib.esm19.js';
import PatreonIcon from './platforms/component-lib.esm18.js';
import PaymentIcon from './component-lib.esm74.js';
import PhoneIcon from './component-lib.esm68.js';
import PinterestIcon from './social-media/component-lib.esm7.js';
import RedditIcon from './platforms/component-lib.esm21.js';
import SignalIcon from './platforms/component-lib.esm24.js';
import SoundcloudIcon from './platforms/component-lib.esm6.js';
import SnapchatIcon from './social-media/component-lib.esm8.js';
import SpotifyIcon from './platforms/component-lib.esm7.js';
import StravaIcon from './platforms/component-lib.esm23.js';
import TelegramIcon from './platforms/component-lib.esm26.js';
import ThreadsIcon from './social-media/component-lib.esm9.js';
import TiktokIcon from './social-media/component-lib.esm11.js';
import TumblrIcon from './platforms/component-lib.esm25.js';
import TwitchIcon from './platforms/component-lib.esm2.js';
import TwitterIcon from './social-media/component-lib.esm10.js';
import UntappdIcon from './platforms/component-lib.esm29.js';
import VimeoIcon from './social-media/component-lib.esm3.js';
import WebsiteIcon from './component-lib.esm34.js';
import WhatsappIcon from './platforms/component-lib.esm30.js';
import XIcon from './social-media/component-lib.esm12.js';
import YoutubeIcon from './social-media/component-lib.esm.js';
const SOCIAL_ACCOUNT_ICONS = {
  AmazonIcon,
  AppleIcon,
  ApplePodcastIcon,
  BandcampIcon,
  BehanceIcon,
  BuyMeACoffeeIcon,
  ClubhouseIcon,
  ChatIcon,
  DiscordIcon,
  EmailIcon,
  EtsyIcon,
  FacebookLetterFIcon,
  FlickrIcon,
  GithubIcon,
  GoogleMyBusinessIcon,
  InstagramIcon,
  KoFiIcon,
  LineIcon,
  LinkedinIcon,
  MastodonIcon,
  MediumIcon,
  MusoIcon,
  PatreonIcon,
  PaymentIcon,
  PhoneIcon,
  PinterestIcon,
  RedditIcon,
  SignalIcon,
  SoundcloudIcon,
  SnapchatIcon,
  SpotifyIcon,
  StravaIcon,
  TelegramIcon,
  ThreadsIcon,
  TiktokIcon,
  TumblrIcon,
  TwitchIcon,
  TwitterIcon,
  UntappdIcon,
  VimeoIcon,
  WebsiteIcon,
  WhatsappIcon,
  XIcon,
  YoutubeIcon
};

/**
 * Get the component name of a social icon
 * @param {String} icon
 * @returns the component name
 */
function getSocialIconComponentName(icon) {
  if (icon.toLowerCase() === 'facebook') return `FacebookLetterFIcon`;
  return `${startCase(icon).replace(/ /g, '')}Icon`;
}
export { SOCIAL_ACCOUNT_ICONS, getSocialIconComponentName };